import React, { Component } from "react"
import Config from '../Config'
import axios from 'axios';
import Axios from 'axios';
import { render } from '@testing-library/react';
import { NotificationManager } from 'react-notifications';
import TinyMCE from 'react-tinymce';
import { createHashHistory } from "history";
import FileBase64 from 'react-file-base64';
import logos from '../layout/pageheader.jpeg'

export default class CreateTicket extends Component {
    constructor (props) {
        super(props)

        this.config = new Config()
        this.$http = this.config.DConnect()
        this.state = {
            reportData: [], smShow: false, isEdit: this.props.isEdit,
            formItems: { id: 0, name: "", email: "", product: "", priority: '', companyName: '', category: '', subject: '', message: '',phone:''}
            , priority: [], product: [], caegory: [], region: [], department: []
            , uploadedFiles: [], files: [], isDisable: false, msg: ''
        }
    }

    componentDidMount() {
        this.getProduct()
        this.getCaegory()
        this.getRegion()
        this.getPriority()
      
    }

    
    // getFiles = (files) => {
    //     this.setState({ files: files })
    // }
    getFiles = (e) => {
        let files = e.target.files
        this.setState({ files })
    }


    getProduct = () => {
        this.$http.get('dropdowns/getDropdownfieldname/product')
            .then(res => {
                let product = res.data
                this.getDeparment()
                this.setState({ product });
            })
    }
    getPriority = () => {
        this.$http.get('dropdowns/getDropdownfieldname/priority')
            .then(res => {
                let priority = res.data
                this.setState({ priority });
            })
    }
    getRegion = () => {
        this.$http.get('dropdowns/getDropdownfieldname/region')
            .then(res => {
                let region = res.data
                this.setState({ region });
            })
    }

    getDeparment = () => {
        this.$http.get('dropdowns/getDropdownfieldname/department')
            .then(res => {
                let department = res.data
                this.setState({ department });
            })
    }
    getCaegory = () => {
        this.$http.get('category/fetchAll')
            .then(res => {
                let caegory = res.data
                this.setState({ caegory });
            })
    }

    ticketid = () => {
        let sValidCharacters = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        var sCharCode = "";
        for (var i = 0; i <= 10; i++) {
            sCharCode = sCharCode + sValidCharacters.charAt(parseInt(Math.random() * sValidCharacters.length))
            if ((i === 2) || (i === 6)) {
                sCharCode = sCharCode + "-"
            }
        }
        return sCharCode
    }

    handleChnage = (e) => {
        let formItems = this.state.formItems
        formItems[e.target.name] = e.target.value
        this.setState({ formItems })
    }
    handleEditorChange = (e) => {
        let formItems = this.state.formItems
        formItems['message'] = e.target.getContent()
        this.setState({ formItems })
    }

    goChart = () => {

    }

    submit = (e) => {
        e.preventDefault()
        this.setState({ isDisable: true, msg: "Connecting to a support team,Please wait..." })
        let files = this.state.files
        let formItems = this.state.formItems
        formItems['ticketid'] = this.ticketid()
        formItems['id'] = 0
        let sname=formItems['name']
        let name=(sname.split(' ') !=undefined)?sname.split(' ')[0]:sname
       

        // this.sendMail(formItems['email'], name, formItems['ticketid'])
        // return
       //alert(JSON.stringify(formItems))
        axios(this.config.PostOptions(formItems, 'ticket/createTicket'))
            .then(res => {
                let user = res.data
               // alert(JSON.stringify(user))
                if (user.status == 1) {
                 
                    this.sendMail(formItems['email'], name, formItems['ticketid'])
                    NotificationManager.success(user.message, 'Successful!', 4000);
                    this.props.history.push('/chatpage/' + formItems['ticketid']);
                    window.location.reload(true)
                    //NotificationManager.success(user.email, 'Successful!', 9000);
                    //this.setState({isDisable:false})

                    // setTimeout(() => {

                    // }, 1000);


                } else {
                    NotificationManager.error(user.message, 'Error!', 4000);
                }
            })

        if (files.length > 0) {
            let formData = this.state.files[0]

            this.LoadMedia(formItems['ticketid'])

        }
        this.setState({ isDisable: false, msg: "Connected..." })
    }

    LoadMedia = (code) => {
        let imgfile = this.state.files[0]
        const fd = new FormData();
        fd.append('pimage', imgfile);
        Axios.post(`${this.config.BaseURLImage()}uploadfiles.php?ticketid=${code}`, fd).then(res => {
            let resdata = res.data
            this.createImage(resdata, code)


        })//.catch(function (error) { alert(error); });
    }

    createImage = (res, code) => {
        let formData = { filename: res.name }
        axios(this.config.PostOptions(formData, `media/createPostmedia/${code}/${res.name}/${code}`))
            .then(res => {
                let respond = res.data
                if (respond.status == 1) {
                    NotificationManager.success(respond.message, 'Successful!', 6000);
                    this.setState({ formItems: { message: '' } })
                    this.componentDidMount()
                } else {
                    NotificationManager.error(respond.message, 'Error!', 4000);
                }
            })
    }

    sendMail = (mail, name, ticketid) => {
        this.$http.get('sendmail/sendTicket/' + mail + "/" + name + "/" + ticketid)
            .then(res => {
                // let caegory = res.data
                // this.setState({ caegory });
            })
    }
    //sendTicket
    render() {
        return (
            <div>
                <div class="hero-section bg_img style-two" style={{ backgroundImage: `url(${logos})` }}>
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-8 col-md-10">
                                <div class="cate-header cl-white">
                                    <h1 class="cate-title">Open New Ticket</h1>
                                    {/* <p>Can’t find the answer you’re looking for? Don't worry! Get in touch with the Docs Support
                                        team, we will be glad to assist you.</p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="contact-form-section padding-bottom pos-rel">
                    <div class="container">
                        <div class="contact-wrapper oh mt--160">
                            <div class="contact-header">
                                <h5 class="title">New Ticket</h5>

                            </div>
                            <form class="contact-form row" id="contact_form_submit" onSubmit={this.submit}>
                                <div class="form-group col-md-6">
                                    <label for="name">Name</label>
                                    <input type="text" id="name" value={this.state.formItems.name} name="name" onChange={this.handleChnage} required placeholder="Your name..." />

                                </div>
                                <div class="form-group col-md-6">
                                    <label for="email">Email Address</label>
                                    <input type="email" id="fname" value={this.state.formItems.email} name="email" onChange={this.handleChnage} required placeholder="Your email.." />
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="lastname">Company</label>
                                    <input type="text" id="companyName" value={this.state.formItems.companyName} onChange={this.handleChnage} name="companyName" required
                                        placeholder="Your Company name..." />
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="phone">Category</label>
                                    <select id="" value={this.state.formItems.category} name="category" required onChange={this.handleChnage} >
                                        <option value="">--Select--</option>
                                        {this.state.caegory.map(itm => (
                                            <option value={itm.id}>{itm.cat_title}</option>
                                        ))}

                                    </select>
                                </div>

                                <div class="form-group col-md-6">
                                    <label for="phone">Priority</label>
                                    <select id="" value={this.state.formItems.priority} name="priority" required onChange={this.handleChnage} >
                                        <option value="">--Select--</option>
                                        {this.state.priority.map(itm => (
                                            <option value={itm.ivalue}>{itm.iname}</option>
                                        ))}

                                    </select>
                                </div>
                                <div class="form-group col-md-6">
                                    <label for="lastname">Phone</label>
                                    <input type="text" name="phone" className="form-control" onChange={this.handleChnage}  />

                                </div>

                                {/* <div class="form-group col-md-6">
                                    <label for="lastname">Attachments</label>
                                    <input type="file" name="pimage" className="form-control" onChange={this.getFiles} multiple />

                                </div> */}

                                <div class="form-group col-md-6">
                                    <label for="product">Product</label>
                                    <select id="product" value={this.state.formItems.product} name="product" required onChange={this.handleChnage} >
                                        <option value="">--Select--</option>
                                        {this.state.product.map(itm => (
                                            <option value={itm.ivalue}>{itm.iname}</option>
                                        ))}

                                    </select>
                                </div>

                                <div class="form-group col-md-6">
                                    <label for="subject" className="pull-left">Subject</label>
                                    <input type="text" id="lname" name="subject" value={this.state.formItems.subject} onChange={this.handleChnage} required placeholder="Your Subject.." />
                                </div>

                                <div class="form-group col-md-12">
                                    <label for="message">Message</label>
                                    <textarea id="message" name="message" value={this.state.formItems.message} onChange={this.handleChnage}></textarea>
                                    <input type="file" name="pimage" className="form-control" onChange={this.getFiles} multiple />
                                </div>
                                <div class="form-group col-md-12">
                                    <div class="form-submit">
                                        <input type="hidden" id="ticketid" name="ticketid" />
                                        <br></br>
                                        <input type="submit" value={(this.state.msg == '') ? "Submit" : this.state.msg} disabled={this.state.isDisable} className="custom-button" />
                                       
                                        {/* <button type="submit" value={(this.state.msg == '') ? "Submit" : this.state.msg} disabled={this.state.isDisable} class="custom-button" /> */}
                                        <p>Need a quick answer? <a href="faq.html">Your answer might be in our FAQs.</a></p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>


          
            </div>


        )
    }
}
